import { render, staticRenderFns } from "./TrackingNotification.vue?vue&type=template&id=0b47761a&"
import script from "./TrackingNotification.vue?vue&type=script&lang=js&"
export * from "./TrackingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports